import React, {useState} from 'react';
import {Link} from "react-router-dom";
import Paper from "@mui/material/Paper";


const UserInfo = ({fName, lName, company, address, email, isConfirm, customerType}) => {
    let items;
    if(customerType === 2){
        items = [
          {
              title: "نام و نام خانوادگی",
              value: fName + " " + lName
          },
          {
              title: "نام شرکت",
              value: company
          },
          {
              title: "آدرس",
              value: address
          },
          {
              title: "ایمیل",
              value: email
          },
          {
              code: 'is_confirm',
              title: "اطلاعات تایید شده؟",
              value: isConfirm
          }
        ];
    }
    else{
        items = [
            {
                title: "نام و نام خانوادگی",
                value: fName + " " + lName
            },
            {
                title: "آدرس",
                value: address
            },
            {
                title: "ایمیل",
                value: email
            },
            {
                code: 'is_confirm',
                title: "اطلاعات تایید شده؟",
                value: isConfirm
            }
        ];

    }
    return (
        <Paper elevation={1} className={'normal-shadow rounded-lg'}>
            <div className="card card-xl-stretch bg-white py-2 pt-0">
                <div className="card-header border-0" style={{padding: "0 1.5rem"}}>
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder text-dark f-09">اطلاعات کاربری</span>
                    </h3>
                    <div className="card-toolbar" data-bs-toggle="tooltip" data-bs-placement="top"
                         data-bs-trigger="hover"
                         title="" data-bs-original-title="اطلاعات کاربری">
                        <Link to={"/edit-profile"}
                              className="btn btn-sm btn-primary btn-light btn-active-primary">
                            <span className={"f-09"}>
                        ویرایش اطلاعات
                    </span>
                        </Link>
                    </div>
                </div>
                <hr style={{backgroundColor: "#999", margin: "0 15px 10px"}}/>
                <div className="card-body pt-2">
                    <div>
                        {
                            items.map((item, index) => (
                                <div key={index}>
                                    <div className="d-flex align-items-center mb-3">
                                        <span className={'bg-secondary bullet bullet-vertical h-40px '}/>
                                        <div className="form-check form-check-custom form-check-solid mx-3"/>
                                        <div className="flex-grow-1">
                                            <div
                                                className="flex-wrap text-gray-800 text-hover-primary fw-bolder d-flex justify-content-between align-items-center">
                                                {
                                                    <span className={"f-09"}> {item.title} </span>
                                                }
                                                {
                                                    item?.code === 'is_confirm' ? <>
                                                        {isConfirm ?
                                                            <span className={'badge badge-light-success'}>بله</span> :
                                                            <span className={'badge badge-light-danger'}>خیر</span>}

                                                    </> : <>
                                                        {
                                                            item ? <span className={"f-09"}>{item.value}</span>
                                                                :
                                                                <span
                                                                    className={"badge badge-light-danger"}>ثبت نشده</span>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        [fName + " " + lName, company, address, email, isConfirm].length !== index + 1 &&
                                        <div className="separator separator-dashed my-3"/>
                                    }

                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </Paper>
    );
};

export default UserInfo;